export function format(formatString, replacements) {
    return formatString.replace(
        /{(\w+)}/g,
        (match, key) => (typeof replacements[key] !== "undefined" ? replacements[key] : match)
    );
}

export function formatClientRoute(formatString, replacements) {
    return formatString.replace(
        /:(\w+)\??/g,
        (match, key) => (typeof replacements[key] !== "undefined" ? replacements[key] : match)
    );
}

export function buildUrl(input, replacements, queryParams) {
    let url = format(input, replacements);

    if (queryParams !== undefined) {
        url += "?";
        Object.keys(queryParams).forEach(s => {
            url += `${s}=${queryParams[s]}&`;
        });
    }

    return url;
}

function isNullOrWhitespace(str) {
    return str === null || str === undefined || str.match(/^\s*$/) !== null;
}

export const StringUtil = {
    isNullOrWhitespace
};
